export const routePermissions = [
	// start of accounting route permissions
	{
		module: "Accounting",
		url: "/accounting/chartofaccount",
		title: "View All Chart of Account",
	},
	{
		module: "Accounting",
		url: "/accounting/addchartofaccount",
		title: "Add Chart of Account",
	},
	{
		module: "Accounting",
		url: "/accounting/chartofaccount/:id",
		title: "Edit Chart of Account",
	},
	{
		module: "Accounting",
		url: "/configuration/glgroupmanagement",
		title: "View All Chart of Account",
	},
	{
		module: "Accounting",
		url: "/accounting/journalentry",
		title: "View All Journal Entry",
	},
	{
		module: "Accounting",
		url: "/accounting/addjournalentry",
		title: "Add Journal Entry",
	},
	// end of accounting route permissions

	// start of approval route permissions
	{
		module: "Approval",
		url: "/approval/customer",
		title: "Act on Customer Approval Requests",
	},
	{
		module: "Approval",
		url: "/approval/customer/:id/view",
		title: "Act on Customer Approval Requests",
	},
	{
		module: "Approval",
		url: "/approval/tellerposting",
		title: "Act on Pending Transaction Posting",
	},
	{
		module: "Approval",
		url: "/approval/pendingloan",
		title: "Act on Pending Loan",
	},
	{
		module: "Approval",
		url: "/approval/manualchargeposting",
		title: "Act on Pending Manual Charge Posting",
	},
	// end of approval route permissions

	// start of configuration route permissions
	{
		module: "Configuration",
		url: "/configuration/branch",
		title: "View All Branches",
	},
	{
		module: "Configuration",
		url: "/configuration/addbranch",
		title: "Add Branch",
	},
	{
		module: "Configuration",
		url: "/configuration/branch/:id",
		title: "Edit Branch",
	},

	{
		module: "Configuration",
		url: "/configuration/savingsproduct",
		title: "View All Savings Products",
	},
	{
		module: "Configuration",
		url: "/configuration/addsavingsproduct",
		title: "Add Savings Product",
	},
	{
		module: "Configuration",
		url: "/configuration/savingsproduct/:id",
		title: "Edit Savings Product",
	},

	{
		module: "Configuration",
		url: "/configuration/currencyexchangerate",
		title: "View All Currency Exchange Rates",
	},
	{
		module: "Configuration",
		url: "/configuration/addcurrencyexchangerate",
		title: "Add Currency Exchange Rate",
	},
	{
		module: "Configuration",
		url: "/configuration/currencyexchangerate/:id",
		title: "Edit Currency Exchange Rate",
	},

	{
		module: "Configuration",
		url: "/configuration/paymentmethod",
		title: "View All Payment Methods",
	},
	{
		module: "Configuration",
		url: "/configuration/addpaymentmethod",
		title: "Add Payment Method",
	},
	{
		module: "Configuration",
		url: "/configuration/paymentmethod/:id",
		title: "Edit Payment Method",
	},

	{
		module: "Configuration",
		url: "/configuration/glbalanceposting",
		title: "Post GL Balance",
	},

	{
		module: "Configuration",
		url: "/configuration/tiermanagement",
		title: "View All Tiers",
	},
	{
		module: "Configuration",
		url: "/configuration/createtier",
		title: "Create Tier",
	},
	{
		module: "Configuration",
		url: "/configuration/tiermanagement/:id",
		title: "Edit Tier",
	},

	{
		module: "Configuration",
		url: "/configuration/systemsettings",
		title: "Update System Settings",
	},

	{
		module: "Configuration",
		url: "/configuration/systemcharge",
		title: "View All System Charge",
	},
	{
		module: "Configuration",
		url: "/configuration/addsystemcharge",
		title: "Add System Charge",
	},
	{
		module: "Configuration",
		url: "/configuration/systemcharge/:id",
		title: "Edit System Charge",
	},

	{
		module: "Configuration",
		url: "/configuration/loanproducts",
		title: "View All Loan Product",
	},
	{
		module: "Configuration",
		url: "/configuration/addloanproduct",
		title: "Add Loan Product",
	},
	{
		module: "Configuration",
		url: "/configuration/loanproduct/:id",
		title: "Edit Loan Product",
	},
	// end of configuration route permissions

	// start of customer service route permissions
	{
		module: "Customer Service",
		url: "/customerservice/customerlist",
		title: "Customer List",
	},
	{
		module: "Customer Service",
		url: "/customerservice/addcustomerlist",
		title: "Add Customer",
	},
	{
		module: "Customer Service",
		url: "/customerlist/customer/:id/edit",
		title: "Edit Customer",
	},
	{
		module: "Customer Service",
		url: "/customerservice/grouplist",
		title: "Group List",
	},
	{
		module: "Customer Service",
		url: "/customerservice/addgrouplist",
		title: "Add Group",
	},
	{
		module: "Customer Service",
		url: "/customerlist/group/:id/edit",
		title: "Edit Group",
	},
	{
		module: "Customer Service",
		url: "/customerservice/printstatement",
		title: "Print Customer Account Statement",
	},
	// end of customer service route permissions

	// start of loan management route permissions
	{
		module: "Loan Management",
		url: "/loanmanagement/application",
		title: "View All Loan",
	},
	{
		module: "Loan Management",
		url: "/loanmanagement/draftapplication",
		title: "Draft Loan Application",
	},
	{
		module: "Loan Management",
		url: "/loanmanagement/application/:id/draft",
		title: "Update Loan Application",
	},

	{
		module: "Loan Management",
		url: "/loanmanagement/application/:id/book",
		title: "Book Loan",
	},
	// end of loan management route permissions

	// start of report route permissions
	{
		module: "Report",
		url: "/report/audittrail",
		title: "View Audit Trail",
	},
	{
		module: "Report",
		url: "/report/disbursedloan",
		title: "View Disbursed Loan Report",
	},
	{
		module: "Report",
		url: "/report/gltransactions",
		title: "View GL Transactions Report",
	},
	{
		module: "Report",
		url: "/report/customer",
		title: "View Customer Report",
	},
	{
		module: "Report",
		url: "/report/group",
		title: "View Group Report",
	},
	{
		module: "Report",
		url: "/report/outstandingloanbalance",
		title: "View Outstanding Loan Balance Report",
	},
	{
		module: "Report",
		url: "/report/loanportfolio",
		title: "View Loan Portfolio Report",
	},
	{
		module: "Report",
		url: "/report/incomestatement",
		title: "View Income Statement Report",
	},
	// end of report route permissions

	// start of teller management route permissions
	{
		module: "Teller Management",
		url: "/tellermanagement/vault",
		title: "Teller Transaction Summary",
	},
	{
		module: "Teller Management",
		url: "/tellermanagement/vault/posttransaction",
		title: "Teller Posting",
	},
	// end of teller management route permissions

	// start of transaction route permissions
	{
		module: "Transactions",
		url: "/accounting/transactionreversal",
		title: "Reversal",
	},
	{
		module: "Transactions",
		url: "/transaction/posting",
		title: "Transaction Posting",
	},
	{
		module: "Transactions",
		url: "/transaction/fundstransfer",
		title: "Funds Transfer",
	},
	// end of transaction route permissions

	// start of user management route permissions
	{
		module: "User Management",
		url: "/usermanagement/mfiuser",
		title: "View All MFI Users",
	},
	{
		module: "User Management",
		url: "/usermanagement/addmfiuser",
		title: "Add MFI User",
	},
	{
		module: "User Management",
		url: "/usermanagement/mfiuser/:id",
		title: "Edit MFI User",
	},

	{
		module: "User Management",
		url: "/usermanagement/role",
		title: "View All Roles",
	},
	{
		module: "User Management",
		url: "/usermanagement/addrole",
		title: "Add Role",
	},
	{
		module: "User Management",
		url: "/usermanagement/role/:id",
		title: "Edit Role",
	},

	{
		module: "User Management",
		url: "/usermanagement/accesscontrol",
		title: "View All Access Control",
	},

	{
		module: "User Management",
		url: "/usermanagement/teller",
		title: "View All Teller",
	},
	{
		module: "User Management",
		url: "/usermanagement/assignteller",
		title: "Assign Teller",
	},
	{
		module: "User Management",
		url: "/usermanagement/teller/:id",
		title: "Edit Teller",
	},
	// end of user management route permissions
];
